import React, { Suspense } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import {
  Routes,
  Route,
  useLocation,
  Navigate,
  useNavigate,
} from "react-router-dom";
import CommonPage from "../Components/CommonPage/CommonPage";
import Footer from "../Components/Footer/Footer";
import Header from "../Components/Header/Header";
import HeaderAccountsPage from "../Components/Header/HeaderAccountsPage";
import Loading from "../Components/Loading/Loading";
import About from "../Screens/About/About";
import Faq from "../Screens/Faq/Faq";
import AccountSettings from "../Screens/Accounts/AccountSettings/AccountSetting";
import BillingDetails from "../Screens/Accounts/AccountSettings/BillingDetails";
import GiftDetails from "../Screens/Accounts/AccountSettings/GiftDetails";
import B2BDetailScreen from "../Screens/B2BDetailsScreen/B2BDetailsScreen";
import StreamingActivity from "../Screens/Accounts/AccountSettings/StreamingActivity";
import ChangePassword from "../Screens/Accounts/ChangePassword/ChangePassword";
import SetPassword from "../Screens/Accounts/SetPassword/SetPassword";
import ForgotPassword from "../Screens/Accounts/ForgotPassword/ForgotPassword";
import ResetPassword from "../Screens/Accounts/ForgotPassword/ResetPassword";
import Login from "../Screens/Accounts/Login/Login";
import Register from "../Screens/Accounts/Register/Register";
import ContactSupport from "../Screens/ContactPages/ContactSupport";
import ContactUs from "../Screens/ContactPages/ContactUs";
import Homepage from "../Screens/homepage/Homepage";
import MyList from "../Screens/MyList/MyList";
import LatestNews from "../Screens/NewsSection/LatestNews";
import NewsDetails from "../Screens/NewsSection/NewsDetails";
import NotFound from "../Screens/NotFound/NotFound";
import GeoBlock from "../Screens/NotFound/GeoBlock";
import PaymentFailed from "../Screens/PaymentStatus/PaymentFailed/PaymetFailed";
import PaymentSuccess from "../Screens/PaymentStatus/PaymentSuccess/PaymentSuccess";
import PrivacyPolicy from "../Screens/PrivacyPolicy/PrivacyPolicy";
import Disclaimer from "../Screens/Disclaimer/Disclaimer";
import Search from "../Screens/Search/Search";
import DetailsScreen from "../Screens/ShowDetailsScreen/DetailsScreen";
import Payment from "../Screens/Subscription/Payment";
import TermsAndConditions from "../Screens/TermsAndConditions/TermsAndConditions";
import PrivateRoutes from "./PrivateRoutes";
import ProtectedRoutes from "./ProtectedRoutes";
import PublicRoutes from "./PublicRoutes";
import LivePlayer from "../Screens/LivePlayer/LivePlayer";
import PodcastModal from "../Components/Modals/PodcastModal";
import WebViewFailed from "../Screens/PaymentStatus/PaymentFailed/WebViewFailed";
import WebViewSuccess from "../Screens/PaymentStatus/PaymentSuccess/WebViewSuccess";
import AffliatePage from "../Screens/AffliatePage/AffliatePage";
import OpenApp from "../Components/OpenApp/OpenApp";
import { checkOperatingSystem } from "../utils/utils";
import LiveChannelsNew from "../Screens/LiveChannels/LiveChannelsNew";
import AffliateTestPage from "../AffliateTestPage";
import LanguageModal from "../Components/Modals/LanguageModal";
import VerifyApp from "../Screens/VerifyApp/VerifyApp";
import { affliateAnalytics } from "../network/service";
import EventDetailsScreen from "../Screens/EventDetails/EventDetailsScreen";
import TopBanner from "../Components/TopBanner/TopBanner";
import CustomHeader from "../Components/Header/CustomHeader";
import TVAppIndex from "../Screens/LinkTvApp/TVAppIndex";
import LoginRequest from "../Screens/LoginRequest/LoginRequest";
import VideoPlayer from "../Screens/VideoPlayer/VideoPlayer";
import ShowAllEpisodes from "../Screens/ShowAllEpisodes/ShowAllEpisodes";
import ContentProducersBlank from "../Components/Header/ContentProducersBlank";
import Shorts from "../Screens/Shorts/Shorts";
import ProgressBar from "../Components/Modals/LoginModal/ProgressBarModal";
import Trailer from "../Screens/Trailer/Trailer";
import { getUpdatePaymentLink } from '../network/service';
import Translate from "../Components/Multilanguage/Translate";
import Calendar from "../Screens/Calendar/Calendar";
import GiftAdd from "../Screens/Gift/GiftAdd";
import GiftClaim from "../Screens/Gift/GiftClaim";
import GiftSuccess from "../Screens/Gift/GiftSuccess";
import GiftFail from "../Screens/Gift/GiftFail";
import ChannelsPage from "../Components/Channels/ChannelsPage";
import RedirectShowCategoryInformation from "../Screens/ShowDetailsScreen/RedirectShowCategoryInformation";
import ContactSupportStatic from "../Screens/ContactPages/ContactSupportStatic";
import FaqStatic from "../Screens/Faq/FaqStatic";
import Favourites from "../Screens/MyList/Favorites";
import PlaylistPage from "../Screens/PlaylistPage/PlaylistPage";
import MyActivity from "../Screens/MyActivity/MyActivity";
import ResubscriptionInfo from "../Components/CommonPage/ResubscriptionInfo";

// Lazy imports
const Subscription = React.lazy(() => import("../Screens/Subscription/Subscription"));
const Checkout = React.lazy(() => import("../Screens/Accounts/Checkout/Checkout"));
const Resubscribe = React.lazy(() => import("../Screens/Accounts/Resubscribe/Resubscribe"));

// Component to handle gift card redemption redirect
const GiftCardRedirect = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const code = searchParams.get('c');

  return <Navigate to={`/gift/claim${code ? `?gc=${code}` : ''}`} replace />;
};

const LayoutsRoutes = () => {
  const location = useLocation();
  const [initialPage, setInitialPage] = useState("");
  const [hideHeaderFooter, setHideHeaderFooter] = useState(false);
  const accessToken = useSelector((state) => state.accessToken?.value);
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const podcastModal = useSelector((state) => state?.podcastModal?.value);
  const languageModal = useSelector(
    (state) => state?.languageModal?.value?.isOpen
  );
  const userDetails = useSelector((state) => state?.userDetails?.value);
  const urlParams = new URLSearchParams(window.location.search);
  const affliateId = localStorage?.getItem("affliateId");
  const navigate = useNavigate();
  const [isOpenAppFeature, setIsOpenAppFeature] = useState(false);
  const [isOpenAppFeatureClosed, setIsOpenFeatureClosed] = useState(false);
  const downloadB2bModal = useSelector((state) => state?.downloadB2bModal?.value);
  const androidToken = urlParams.get("antkn");
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;
  const appInfo = {
    accessToken: accessToken,
    projectDetails: projectInfo,
  };
  const [isCheckoutPath, setIsCheckoutPath] = useState(false);

  useEffect(() => {
    setIsCheckoutPath(/^\/checkout(\/.*)?$/.test(location?.pathname));
  }, [location?.pathname]);

  useEffect(() => {
    if (urlParams.has('d') && urlParams.get('d') === 'm') {
      setHideHeaderFooter(true);
    } else {
      setHideHeaderFooter(false);
    }
  }, [urlParams]);

  useEffect(() => {
    if (!androidToken) {
      let openAppFeatureNotNeededRoutes = ["/privacy-policy", "/terms-and-conditions", "/subscription", "/payment", "/success", "/failed", "/404", "/checkout"];
      // Use the state variable instead of re-calculating
      if (
        (checkOperatingSystem() === "android" ||
          checkOperatingSystem() === "iPhone") &&
        !openAppFeatureNotNeededRoutes?.includes(location?.pathname)
        && !isCheckoutPath
        &&
        projectInfo?.projectConfig?.config?.DEEP_LINKING_ENABLED === "true"
        &&
        isOpenAppFeatureClosed === false
      ) {
        setIsOpenAppFeature(true);
      } else {
        setIsOpenAppFeature(false)
      }
    }
  }, [androidToken, location, isCheckoutPath]);

  useEffect(() => {
    if (affliateId) {
      // console.log("Affiliate ID detected", affliateId);

      if (checkOperatingSystem() === "android" || checkOperatingSystem() === "iPhone") {
        setInitialPage(projectInfo?.projectConfig?.config?.INITIAL_PAGE);
        updateAffliateAnalytics()

      } else {
        setInitialPage(projectInfo?.projectConfig?.config?.INITIAL_PAGE);
        updateAffliateAnalytics()
      }
    } else {
      setInitialPage(projectInfo?.projectConfig?.config?.INITIAL_PAGE);

    }
  }, []);

  const updateAffliateAnalytics = async () => {
    try {
      const response = await affliateAnalytics(appInfo);
      if (response.status === 200) {
        localStorage.removeItem("affliateId");
        localStorage.removeItem("affliateUrl");
        navigate(location?.pathname)

      }
    } catch (err) {
      localStorage.removeItem("affliateId");
      localStorage.removeItem("affliateUrl");
    }
  }

  const updatePaymentDetails = async () => {
    const response = await getUpdatePaymentLink(appInfo);
    if (response.status === 200) {
      // console.log(response.data);
      if (response.data?.url) {
        window.location.href = response.data.url;
      }
    }
  }

  const resubscribe = () => {
    navigate('/checkout/resubscribe', { state: { userSubscriptionId: userDetails?.user_subscription_id } });
  }

  if (affliateId && (checkOperatingSystem() === "android" || checkOperatingSystem() === "iPhone")) {
    return (
      <Routes>
        <Route path="/">
          <Route path="/" element={<Navigate to="/redirect" />} />
        </Route>
        <Route path="/redirect" element={<AffliatePage />} />
      </Routes>
    );
  } else {

    function RedirectToRegisterWithIOSProps() {
      const navigate = useNavigate();

      useEffect(() => {
        localStorage.setItem('iosSignup', true);
        navigate('/register', { state: { iosSignup: true } });
      }, [navigate]);
      return null;
    }



    return (
      initialPage && (
        <div id="main" className="LayoutsContainer">
          {projectInfo?.projectConfig?.config?.WEBSITE_NOT_NEEDED !== "true" && location?.pathname !== "/login" &&
            location?.pathname !== "/register" &&
            location?.pathname !== "/ios-signup" &&
            location?.pathname !== "/forgot-password" &&
            location?.pathname !== "/forgot-password/reset" &&
            projectInfo?.projectConfig?.config?.CUSTOM_HEADER_REQUIRED !== "true"
            ? initialPage !== "AFFLIATEPAGE" && localStorage.getItem('iosSignup') != 'true' && (
              <>
                {
                  // !hideHeaderFooter && !androidToken && <Header />
                  !hideHeaderFooter && !androidToken && (
                    // template === "TEMPLATE_10" ? <GaiaHeader isCheckoutPath={isCheckoutPath} /> : template === "TEMPLATE_11" ? <NewBlockHeader /> :  <Header />
                    <Header />
                  )
                }

                {/* <TopBanner/> */}
              </>
            ) : projectInfo?.projectConfig?.config?.WEBSITE_NOT_NEEDED !== "true" &&
              projectInfo?.projectConfig?.config?.CUSTOM_HEADER_REQUIRED === "true"
              ? initialPage !== "AFFLIATEPAGE" && (
                <CustomHeader />
              )
              : initialPage !== "AFFLIATEPAGE" && projectInfo?.projectConfig?.config?.WEBSITE_NOT_NEEDED !== "true" && projectInfo?.projectConfig?.config?.CUSTOM_HEADER_REQUIRED !== "true" && <HeaderAccountsPage />}
          {podcastModal?.isOpen && <PodcastModal data={podcastModal?.data} />}

          {languageModal?.isOpen && <LanguageModal />}

          {isOpenAppFeature && (
            <OpenApp setIsOpenAppFeature={setIsOpenAppFeature} setIsOpenFeatureClosed={setIsOpenFeatureClosed} />
          )}

          {userDetails?.default_payment_method_exists === false && !isCheckoutPath &&
            < div className="resubscriptionInfo">
              <div className="resubscribeMessage">
                <Translate textKey={'update_payment_method_message'} />
              </div>
              <div className="resubscribeButton" onClick={() => { updatePaymentDetails() }} style={{ backgroundColor: projectInfo?.projectConfig?.config?.BACKGROUND_COLOR, color: projectInfo?.projectConfig?.config?.TEXT_COLOR, border: `1px solid ${projectInfo?.projectConfig?.config?.TEXT_COLOR}` }}>
                <Translate textKey={'update'} />
              </div>
            </div>
          }

          {userDetails?.user_subscription_id && location?.pathname !== "/resubscribe" && !isCheckoutPath &&
            <ResubscriptionInfo resubscribe={resubscribe} />
          }

          <div className="routesContainer" >
            {
              projectInfo?.projectConfig?.config?.GEO_BLOCKED === true &&
                !projectInfo?.projectConfig?.config?.GEO_UNBLOCKED_COUNTRIES.includes(projectInfo?.geoInfo.countryCode) ? (
                <GeoBlock />
              ) :
                (<Routes>
                  {/* for which page need to show initial */}
                  <Route element={<PrivateRoutes />}>
                    <Route path="/" element={localStorage.getItem('iosSignup') == 'true' ? <Navigate to="/subscription" /> : <Homepage />} />
                  </Route>

                  <Route element={<PublicRoutes />}>

                    <Route path="/checkout/:subscribe/:purchase" element={<Navigate to="/register" />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/login-via-email" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    {/* <Route path="/ios-signup" element={<Register iosSignup={true} />} /> */}
                    <Route path="/ios-signup" element={<RedirectToRegisterWithIOSProps />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/B2B/:name" element={<B2BDetailScreen />} />
                  </Route>

                  <Route path="/loginRequest" element={<LoginRequest />} />

                  <Route element={<PrivateRoutes />}>
                    <Route path="/sample" element={<AffliateTestPage />} />
                    <Route path="/verify-app" element={<VerifyApp />} />
                    <Route path="/videos/:vanityUrl" element={<VideoPlayer />} />
                    <Route
                      path="/episode/:vanityUrl"
                      element={<Navigate to={`/videos/${location.pathname.split('/').pop()}`} state={location?.state} />}
                    />
                    <Route path="/trailer/:vanity" element={<Trailer />} />
                    <Route path="/video/:vanityUrl" element={<DetailsScreen />} />

                    <Route path="/home" element={<Navigate to="/" />} />
                    <Route path="/:name" element={<RedirectShowCategoryInformation />} />

                    <Route path="/show-details/:name" element={<DetailsScreen />} />
                    <Route
                      path="/show/:name"
                      element={<Navigate to={`/show-details/${location.pathname.split('/').pop()}`} state={location?.state} />}
                    />
                    <Route
                      path="/programs/:name"
                      element={<Navigate to={`/show-details/${location.pathname.split('/').pop()}`} state={location?.state} />}
                    />

                    <Route path="/event/:eventId" element={<EventDetailsScreen />} />
                    <Route path="/category/:careers" element={<CommonPage />} />
                    <Route
                      path="/categories/:careers"
                      element={<Navigate to={`/category/${location.pathname.split('/').pop()}`} />}
                    />
                    <Route path="/channels" element={<ChannelsPage />} />
                    <Route path="/genre/:key" element={<Homepage />} />
                    <Route path="/partner/:partnerId" element={<CommonPage />} />
                    <Route path="/calendar" element={<Calendar />} />
                    <Route
                      path="/calendar/:date"
                      element={<Navigate to={"/calendar"} />}
                    />
                    <Route path="/search" element={<Search />} />
                    {projectInfo?.projectConfig?.config?.GIFT_REQUIRED === "true" && (
                      <>
                        <Route path="/gift/purchase" element={<GiftAdd />} />
                        <Route path="/gift/claim" element={<GiftClaim />} />
                        <Route path="/gift/success" element={<GiftSuccess />} />
                        <Route path="/gift/failed" element={<GiftFail />} />
                        <Route
                          path="/gifts/purchases/new"
                          element={<Navigate to={"/gift/purchase"} />}
                        />
                        <Route
                          path="/gift_card_redemptions/new"
                          element={<Navigate to={"/gift/claim"} />}
                        />
                        <Route
                          path="/gift_cards/redemptions/new"
                          element={<GiftCardRedirect />}
                        />
                      </>
                    )}
                    <Route path="/episodes/:showname" element={<ShowAllEpisodes />} />
                    <Route
                      path="/forgot-password/reset/:token"
                      element={<ResetPassword />}
                    />
                    <Route path="/language-selection" element={<LanguageModal type="root" />} />
                    <Route
                      path="/terms-and-conditions"
                      element={<TermsAndConditions />}
                    />
                    <Route
                      path="/pages/terms-of-service"
                      element={<Navigate to={"/terms-and-conditions"} />}
                    />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route
                      path="/pages/privacy-policy"
                      element={<Navigate to={"/privacy-policy"} />}
                    />
                    <Route path="/disclaimer" element={<Disclaimer />} />
                    <Route path="/contact-us" element={<ContactUs />} />
                    <Route
                      path="/pages/contact-us"
                      element={<Navigate to={"/contact-support"} />}
                    />
                    <Route path="/resubscribe" element={<Suspense fallback={<Loading />}><Resubscribe /></Suspense>} />
                    {/* <Route path="/contact-support" element={<ContactSupport />} /> */}
                    <Route path="/contact-support" element={<ContactSupportStatic />} />
                    <Route path="/about-us" element={(<About />)} />
                    <Route path="/faq" element={<FaqStatic />} />
                    <Route path="/news" element={<LatestNews />} />
                    <Route path="/news-info/:newsId" element={<NewsDetails />} />
                    <Route path="/subscription" element={<Suspense fallback={<Loading />}><Subscription /></Suspense>} />
                    <Route path="/checkout" element={<Suspense fallback={<Loading />}><Checkout /></Suspense>} />
                    <Route
                      path="/join_us"
                      element={<Navigate to={"/checkout"} />}
                    />
                    <Route
                      path="/join"
                      element={<Navigate to={"/checkout"} />}
                    />
                    <Route
                      path="/sign_in"
                      element={<Navigate to={"/checkout"} />}
                    />
                    <Route path="/checkout/:key" element={<Suspense fallback={<Loading />}><Checkout /></Suspense>} />
                    <Route path="/redirect" element={<Navigate to="/" />} />
                    <Route path="/browse" element={<Navigate to="/" />} />
                    <Route path="/affliate" element={<AffliatePage />} />
                    <Route path="/live-channels" element={<LiveChannelsNew />} />
                    <Route path="/livestream" element={<LiveChannelsNew />} />
                    <Route path="/live" element={<LivePlayer />} />
                    <Route path="/watch-event/:vanityUrl" element={<LivePlayer />} />
                    <Route path="/player" element={<Navigate to="/live" state={location?.state} />} />
                    <Route path="/blank" element={<ContentProducersBlank />} />
                    <Route path="/catalog" element={<Navigate to="/" state={location?.state} />} />
                  </Route>

                  <Route element={<ProtectedRoutes />}>
                    <Route path="/shorts" element={<Shorts />} />
                    <Route path="/shorts/:vanityUrl" element={<Shorts />} />
                    <Route path="/failed" element={<PaymentFailed />} />
                    <Route path="/webviewfailed" element={<WebViewFailed />} />
                    <Route path="/success" element={<PaymentSuccess />} />
                    <Route path="/webviewsuccess" element={<WebViewSuccess />} />
                    <Route path="/change-password" element={<ChangePassword />} />
                    <Route path="/set-password" element={<SetPassword />} />
                    <Route path="/account" element={<AccountSettings />} />
                    <Route
                      path="account/billing-activity"
                      element={<BillingDetails />}
                    />
                    {projectInfo?.projectConfig?.config?.GIFT_REQUIRED === "true" &&
                      <Route
                        path="account/gift-activity"
                        element={<GiftDetails />}
                      />
                    }
                    <Route
                      path="account/streaming-activity"
                      element={<StreamingActivity />}
                    />
                    <Route path="/resubscribe" element={<Suspense fallback={<Loading />}><Resubscribe /></Suspense>} />
                    <Route path="/payment" element={<Payment />} />
                    {/* <Route path="/my-list" element={<MyList />} /> */}
                    <Route path="/my-list" element={<Favourites />} />
                    <Route path="/my-list/:playlistId" element={<PlaylistPage />} />
                    <Route path="/tv" element={<TVAppIndex />} />
                    <Route path="/connect" element={<Navigate to={"/tv"} />} />
                    <Route path="/my-activity" element={<MyActivity />} />
                  </Route>

                  <Route path="*" element={<Navigate to="/404" />}></Route>
                  <Route path="/404" element={<NotFound />} />


                </Routes>)
            }
          </div>

          {
            downloadB2bModal?.downloadProgress && <ProgressBar downloadB2bModal={downloadB2bModal} />
          }

          {initialPage !== "AFFLIATEPAGE" && projectInfo?.projectConfig?.config?.WEBSITE_NOT_NEEDED !== "true" && localStorage.getItem('iosSignup') != 'true' &&
            !hideHeaderFooter && !androidToken && <Footer style={{ flexShrink: 0 }} />}
        </div>
      )
    );
  }
};

export default LayoutsRoutes;
